/**
 * @desc 审批
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(body: defs.business.TheExaminationAndApprovalParameters, options?: any) {
  return updateResponse(
    http(URL + `/customerOrder/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
